import React, { useCallback } from 'react';
import { Button } from '~/shared/components';

export interface DateFilterRangeButtonProps {
  text: string;
  value: string;
  selected: boolean;
  onSelect: (value: string) => void;
}

const DateFilterRangeButton = ({ text, value, selected, onSelect }: DateFilterRangeButtonProps) => {
  const handleClick = useCallback(() => {
    onSelect(value);
  }, [onSelect, value]);

  return (
    <Button onClick={handleClick} className={selected ? 'range-button-selected' : 'range-button'}>
      {text}
    </Button>
  );
};

export default DateFilterRangeButton;
